export default __webpack_public_path__ + "static/media/cx_cover_c50s.cabcc66d.jpg";